import {
  ContentLayout,
  HeaderBreadcrumbs,
  LoadingButton,
  Loader,
} from "../../../shared";
import * as React from "react";
import {
  Button,
  Stack,
  Typography,
  Grid,
  Card,
  Box,
  Divider,
  FormHelperText,
  Chip,
  Checkbox,
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import InputControl from "../../../shared/components/InputControl";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useAddorEditStampReward } from "../hooks";
import { DropzoneComponents } from "../../BirthdayCoupons/components";
import { findProductType } from "../../../utils";

export const AddorEditStampReward = () => {
  const {
    state,
    validator,
    handleInputChange,
    onImageChange,
    handleDescriptionChange,
    handleSubmit,
    productCategories,
    breadcrumbLinks,
    isEditMode,
    setProductsForGroup,
    removeProductFromGroup,
    addRewardGroup,
    removeRewardGroup,
    updateGroupTitle,
  } = useAddorEditStampReward();

  const {
    stamps_unlock,
    reward_title,
    description,
    validity,

    reward_groups,
  } = state.data;

  const { mobile_image, desktop_image } = state.imagePreview;

  return (
    <>
      {validator.current.purgeFields()}
      <ContentLayout
        title={isEditMode ? "Edit Stamp Card" : "New Stamp Card"}
        breadcrumbs={<HeaderBreadcrumbs links={breadcrumbLinks} />}
        rightContent={
          <LoadingButton
            variant={isEditMode ? "contained" : "text"}
            color="primary"
            // sx={{ background: "#F5F8FF", color: "#3B6DD8" }}
            loading={state.isSaving}
            onClick={() => handleSubmit(true)}
          >
            {isEditMode ? "Save" : "Save as Draft"}
          </LoadingButton>
        }
      >
        {state.isLoading ? (
          <Loader />
        ) : (
          <Card sx={{ p: "32px 24px", mb: "24px" }}>
            <Grid container spacing={3}>
              {/* Stamp Card Name */}
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Basic Details
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8}>
                <Stack width="100%" gap="20px">
                  <Stack
                    sx={{
                      flexDirection: "row",
                    }}
                    width="100%"
                    gap="20px"
                  >
                    <InputControl
                      name="stamps_unlock"
                      label="Stamps to Unlock"
                      autoComplete="off"
                      type="number"
                      value={stamps_unlock}
                      onChange={handleInputChange}
                      required
                      error={validator.current.message(
                        "Stamps to Unlock",
                        stamps_unlock,
                        "required|integer|min:1,num",
                      )}
                      helperText={validator.current.message(
                        "Stamps to Unlock",
                        stamps_unlock,
                        "required|integer|min:1,num",
                      )}
                    />
                    <InputControl
                      name="reward_title"
                      label="Reward Title"
                      autoComplete="off"
                      value={reward_title}
                      onChange={handleInputChange}
                      required
                      error={validator.current.message(
                        "Reward Title",
                        reward_title,
                        "required",
                      )}
                      helperText={validator.current.message(
                        "Reward Title",
                        reward_title,
                        "required",
                      )}
                    />
                  </Stack>
                  <Stack width="100%" gap="6px">
                    <InputControl
                      name="validity"
                      label="Validity (Days)"
                      type="number"
                      autoComplete="off"
                      value={validity}
                      onChange={handleInputChange}
                      required
                      error={validator.current.message(
                        "Validity",
                        validity,
                        "required|numeric",
                      )}
                      helperText={validator.current.message(
                        "Validity",
                        validity,
                        "required|numeric",
                      )}
                    />
                    <Stack
                      sx={{
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        padding: "6px 4px",
                      }}
                    >
                      <img
                        style={{
                          height: "14px",
                        }}
                        alt="details"
                        src="/icons/ic_info.svg"
                      />
                      <Typography
                        variant="caption"
                        lineHeight="15px"
                        color="#666666"
                      >
                        Set how long a stamp cycle stays active from the first
                        stamp.
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Grid>

              <Divider sx={{ width: "100%", mt: 3 }} />

              {/* Description */}
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Description
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8}>
                <Stack width="100%" gap="20px">
                  <InputControl
                    type="textarea"
                    rows={4}
                    name="description"
                    label="Description"
                    value={description}
                    onChange={handleInputChange}
                    required
                    error={validator.current.message(
                      "description",
                      description,
                      "required",
                    )}
                    helperText={validator.current.message(
                      "description",
                      description,
                      "required",
                    )}
                  />
                 
                </Stack>
              </Grid>

              <Divider sx={{ width: "100%", mt: 3 }} />

              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Images
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8}>
                <Stack
                  sx={{
                    flexDirection: "row",
                  }}
                  width="100%"
                  gap="20px"
                >
                  <Stack width="400px">
                    <DropzoneComponents
                      imgUrl={mobile_image ?? ""}
                      handleDropzone={(e) => {
                        onImageChange(e, "mobile_image");
                      }}
                      aspectRatio="1/1"
                    />
                  </Stack>
                  <Stack width="400px">
                    <DropzoneComponents
                      imgUrl={desktop_image ?? ""}
                      handleDropzone={(e) => {
                        onImageChange(e, "desktop_image");
                      }}
                      aspectRatio="2/1"
                    />
                  </Stack>
                </Stack>
              </Grid>

              <Divider sx={{ width: "100%", mt: 3 }} />

              {/* Total Stamps */}
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Reward Products
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8}>
                {reward_groups?.map((data, index) => (
                  <Stack width="100%" gap="20px" key={index}>
                    {index !== 0 && (
                      <Divider sx={{ my: 2, borderColor: "#E0E0E0" }} />
                    )}
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography variant="subtitle1" fontWeight={600}>
                        Group {index + 1}
                      </Typography>
                      {reward_groups.length > 1 && (
                        <Button
                          type="button"
                          size="medium"
                          variant="text"
                          color="error"
                          onClick={() => removeRewardGroup(index)}
                        >
                          Remove
                        </Button>
                      )}
                    </Stack>

                    <InputControl
                      name="group_title"
                      label="Group Title"
                      autoComplete="off"
                      value={data.group_title}
                      onChange={(e) => updateGroupTitle(index, e)}
                      required
                      error={validator.current.message(
                        `group title${" ".repeat(index)}`,
                        data.group_title,
                        "required",
                      )}
                      helperText={validator.current.message(
                        `group title${" ".repeat(index)}`,
                        data.group_title,
                        "required",
                      )}
                    />
                    <Stack>
                      <Box sx={{ width: "100%" }}>
                        <Stack
                          sx={{
                            flexDirection: "row",
                            gap: "20px",
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          {(() => {
                            const selectedProductIdsInOtherGroups =
                              reward_groups
                                ?.flatMap((group, groupIndex) => {
                                  if (groupIndex === index) {
                                    return [];
                                  }
                                  return (group.products || []).map(
                                    (product) => product.id,
                                  );
                                })
                                .filter(Boolean) || [];

                            const selectedProducts =
                              data?.products?.map((product) => ({
                                value: product.id,
                                label: product.name,
                              })) || [];

                            const optionByGroup = productCategories
                              .map((category) => ({
                                ...category,
                                products: category.products.filter(
                                  (product) => {
                                    const alreadySelectedInOtherGroup =
                                      selectedProductIdsInOtherGroups.includes(
                                        product.value,
                                      );

                                    const selectedInCurrentGroup =
                                      selectedProducts.some(
                                        (selectedProduct) =>
                                          selectedProduct.value ===
                                          product.value,
                                      );

                                    return (
                                      !alreadySelectedInOtherGroup ||
                                      selectedInCurrentGroup
                                    );
                                  },
                                ),
                              }))
                              .filter(
                                (category) => category.products.length > 0,
                              );

                            return (
                              <CategoryProductDropdown
                                options={optionByGroup}
                                value={selectedProducts}
                                onChange={(selectedProducts) => {
                                  setProductsForGroup(index, selectedProducts);
                                }}
                              />
                            );
                          })()}
                        </Stack>
                        <FormHelperText sx={{ color: "#C60808" }}>
                          {validator.current.message(
                            `product${" ".repeat(index)}`,
                            data?.products?.length,
                            "required|pro",
                          )}
                        </FormHelperText>
                      </Box>
                      <Stack
                        sx={{
                          flexDirection: "row",
                          gap: "4px",
                          alignItems: "center",
                          padding: "6px 4px",
                        }}
                      >
                        <img
                          style={{
                            height: "18px",
                          }}
                          alt="details"
                          src="/icons/ic_info.svg"
                        />
                        <Typography
                          variant="caption"
                          lineHeight="15px"
                          color="#666666"
                        >
                          Selected products will be used as rewards for the
                          stamp card milestone.
                        </Typography>
                      </Stack>
                      <Stack
                        sx={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: "10px",
                        }}
                      >
                        {data?.products?.map((data, i) => (
                          <Chip
                            key={i}
                            label={
                              <Typography variant="body2" fontSize="14px">
                                {data?.name}
                              </Typography>
                            }
                            onDelete={() => {
                              removeProductFromGroup(index, i);
                            }}
                            sx={{
                              backgroundColor: "#F2F2F2",
                              height: "30px",
                              "& .MuiChip-deleteIcon": {
                                color: "#CCCCCC",
                              },
                            }}
                          />
                        ))}
                      </Stack>
                    </Stack>
                  </Stack>
                ))}
                <Button
                  type="button"
                  size="medium"
                  variant="text"
                  color="info"
                  sx={{ mt: "10px" }}
                  startIcon={<AddIcon />}
                  onClick={addRewardGroup}
                >
                  Add Group{" "}
                </Button>
              </Grid>
            </Grid>
          </Card>
        )}
      </ContentLayout>
    </>
  );
};

const CategoryProductDropdown = ({ options, value = [], onChange }) => {
  const [open, setOpen] = React.useState(null);
  const [inputValue, setInputValue] = React.useState("");

  const isSelected = (product) => {
    return value.some((item) => item.value === product.value);
  };

  const isCategoryIndeterminate = (category) => {
    if (!category.products.length || !value.length) return false;
    const commonIDs = value.filter((selectedProduct) =>
      category.products.some(
        (categoryProduct) => selectedProduct.value === categoryProduct.value,
      ),
    );
    const allSelected = category.products.every((categoryProduct) =>
      value.find(
        (selectedProduct) => selectedProduct.value === categoryProduct.value,
      ),
    );
    return commonIDs.length > 0 && !allSelected;
  };

  const isCategorySelected = (category) => {
    if (!category.products.length || !value.length) return false;
    return category.products.every((categoryProduct) =>
      value.find(
        (selectedProduct) => selectedProduct.value === categoryProduct.value,
      ),
    );
  };

  const handleCategoryToggle = (category, checked) => {
    if (checked) {
      const selectedIds = value.map((item) => item.value);
      const newProducts = category.products.filter(
        (product) => !selectedIds.includes(product.value),
      );
      onChange([...value, ...newProducts]);
    } else {
      const categoryProductIds = category.products.map((item) => item.value);
      onChange(
        value.filter((item) => !categoryProductIds.includes(item.value)),
      );
    }
    setInputValue("");
  };

  const filteredOptions = React.useMemo(() => {
    const search = inputValue.trim().toLowerCase();
    if (!search) return options;

    return options
      .map((category) => ({
        ...category,
        products: category.products.filter((product) =>
          product.label.toLowerCase().includes(search),
        ),
      }))
      .filter((category) => category.products.length > 0);
  }, [options, inputValue]);

  return (
    <InputControl
      name="reward_products"
      type="dropdown"
      multiple
      disableCloseOnSelect
      disableClearable
      options={filteredOptions || []}
      className="tags-input"
      renderOption={(props, category) => (
        <React.Fragment key={category.id}>
          <ListItemButton
            sx={{
              borderBottom: "1px solid #E6E6E6",
            }}
            onClick={() => {
              setOpen(open === category.id ? null : category.id);
            }}
          >
            <Checkbox
              style={{ marginRight: 8 }}
              indeterminate={isCategoryIndeterminate(category)}
              checked={isCategorySelected(category)}
              onChange={(e, checked) => {
                handleCategoryToggle(category, checked);
              }}
            />
            <ListItemText
              primary={
                <Typography
                  sx={{ display: "inline", fontWeight: 600 }}
                  component="span"
                  variant="subtitle2"
                  color="#171717"
                >
                  {category.name} ({category.products.length})
                </Typography>
              }
            />
            {category.products.length > 0 && (
              <img
                alt="toggle"
                src="/icons/ic_dropdown.svg"
                style={{
                  transform: open === category.id ? "" : "rotate(180deg)",
                }}
              />
            )}
          </ListItemButton>

          <Collapse in={open === category.id} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {category.products.map((product) => (
                <ListItem
                  key={product.value}
                  {...props}
                  onClick={() => {
                    if (isSelected(product)) {
                      onChange(
                        value.filter((item) => item.value !== product.value),
                      );
                    } else {
                      onChange([...value, product]);
                    }
                    setInputValue("");
                  }}
                >
                  <Checkbox
                    style={{ marginRight: 8, marginLeft: 12 }}
                    checked={isSelected(product)}
                  />
                  {product.label}
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "50px",
                      height: "18px",
                      width: "18px",
                      backgroundColor: "#1560D414",
                      color: "#1560D4",
                      fontSize: "10px",
                      marginLeft: "6px",
                    }}
                  >
                    {findProductType(product.type)}
                  </span>
                </ListItem>
              ))}
            </List>
          </Collapse>
        </React.Fragment>
      )}
      renderTags={() => null}
      filterOptions={(options) => options}
      onInputChange={(event, newInputValue, reason) => {
        if (reason !== "reset") {
          setInputValue(newInputValue);
        }
      }}
      inputValue={inputValue}
      value={value || []}
      renderInput={(params) => (
        <TextField {...params} label="Product" placeholder="Product" />
      )}
    />
  );
};
